import FlexCard from "@components/flex-card";
import AuthenticatedLayout from "../../layouts/authenticated";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ActionBar from "@components/action-bar";
import ActionButton from "@components/action-button";
import MiniTable from "@components/mini-table";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import { fetchSignatarios } from "../../store/assinatura";
import { useSelector } from "react-redux";
import SignatarioDrawer from "./_SignatarioDrawer";
import SignatariosBaseTable from "@components/table-signatarios";
import BreadcrumbTitulo from "@/components/breadcrumb-titulo";
import unwrapAxiosPromise from "@/util/unwrapAxiosPromise";

function SignatariosPage() {
  const { t } = useTranslation();
  const miniTableRef = useRef();
  const dispatch = useDispatchWithResult();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [loadingDrawer, setLoadingDrawer] = useState(false);
  const [activeSearch, setActiveSearch] = useState();

  const { signatarios } = useSelector((state) => state.assinaturas);

  const [selectedIds, setSelectedIds] = useState([]);
  const [signatario, setSignatario] = useState();
  const [signatarioDrawerVisible, setSignatarioDrawerVisible] = useState(false);

  useEffect(() => {
    unwrapAxiosPromise(dispatch(fetchSignatarios()));
  }, []);

  const handleSearch = (search) => {
    setLoadingSearch(true);
    dispatch(fetchSignatarios(search))
      .then(() => {
        setActiveSearch(search);
      })
      .finally(() => setLoadingSearch(false));
  };

  const handleCreateClick = () => {
    setSignatario(undefined);
    setSignatarioDrawerVisible(true);
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    //chamada à API para remover signatario
  };

  const handleClick = (signatario) => {
    setSignatarioDrawerVisible(true);
    setSignatario(signatario);
  };

  const handleSignatarioChange = () => {
    handleSearch(activeSearch);
  };

  const handleSignatarioDrawerClose = () => {
    setSignatarioDrawerVisible(false);
  };

  const handleSignatarioDrawerAfterClose = () => {
    setSignatario(undefined);
  };

  return (
    <AuthenticatedLayout breadcrumb={[t("Signatários")]}>
      <FlexCard
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <BreadcrumbTitulo selected={t("Signatários")} />
            <ActionBar onSearch={handleSearch} searchFormatter="cpf">
              <ActionButton.Create onClick={handleCreateClick} />
              {/* <ActionButton.Remove disabled={selectedIds.length === 0} onClick={handleRemove} loading={loadingRemove} /> */}
              <MiniTable.DownloadButton disabled={loadingSearch || loadingRemove || signatarios.length === 0} miniTableRef={miniTableRef} />
            </ActionBar>
          </div>
        }
        headStyle={{ backgroundColor: "#f0f0f06b" }}
      >
        <SignatariosBaseTable dataSource={signatarios} loading={loadingSearch || loadingRemove} miniTableRef={miniTableRef} onClick={handleClick} onSelectedIdsChange={setSelectedIds} selectedIds={selectedIds} isCadastro={true} />
      </FlexCard>
      <SignatarioDrawer loading={loadingDrawer} onAfterClose={handleSignatarioDrawerAfterClose} onChange={handleSignatarioChange} onClose={handleSignatarioDrawerClose} value={signatario} visible={signatarioDrawerVisible} />
    </AuthenticatedLayout>
  );
}

export default SignatariosPage;
